<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                        <el-breadcrumb-item>员工KPI</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-tabs v-model="activeName">
                <el-tab-pane label="月度" name="month">
                    <StaffKPIList :pt="0"></StaffKPIList>
                </el-tab-pane>
                <el-tab-pane label="季度" name="quarter">
                    <StaffKPIList :pt="1"></StaffKPIList>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
import StaffKPIList from "../KPI/StaffKPIList";
export default {
  data() {
    return {
      activeName: "month",
    };
  },
  components: {
    StaffKPIList
  }
}
</script>

